import { render } from "./PremiumLoader.vue?vue&type=template&id=009de90e"
import script from "./PremiumLoader.vue?vue&type=script&lang=js"
export * from "./PremiumLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__